import { ml } from "../../../../../core/common/matrixlib";
import {
    IPrintFunction,
    IGlobalPrintFunctionParams,
    IPrintFunctionParams,
} from "../../../../../core/printinterface/PrintFunction";
import { IPrintGlobals } from "../../../../../core/printinterface/PrintProcessorInterfaces";
import { PrintProcessor } from "../../../PrintProcessor";
import { IPrintFieldParams } from "../../../PrintValueOf";

export type { IFieldTextlineParams };
export { FieldTextline };

interface IFieldTextlineParams extends IPrintFieldParams {
    class: string; // default:"". additional class for outermost container
}

class FieldTextline implements IPrintFunction {
    static uid = PrintProcessor.getFieldFunctionId("textline");

    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    getGroup() {
        return PrintProcessor.FIELD_FUNCTION_TYPE;
    }

    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    getHelp() {
        return `<h2>text line</h2>
    <p>No options</p>`;
    }
    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    getName() {
        return "Textline field renderer (default implementation)n";
    }

    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    async renderAsync(
        overwrites: IGlobalPrintFunctionParams,
        paramsIn: IPrintFunctionParams,
        itemOrFolderRef: string,
        itemOrFolder: JQuery,
        mf: JQuery,
        globals: IPrintGlobals,
        possibleTargets: string[],
        onError: (message: string) => void,
    ) {
        const paramsCaller = <IFieldTextlineParams>paramsIn;
        const defaults: IFieldTextlineParams = {
            class: ``,
        };

        const params = ml.JSON.clone({
            ...defaults,
            ...overwrites.customer[FieldTextline.uid],
            ...paramsCaller,
            ...overwrites.project[FieldTextline.uid],
            ...overwrites.section[FieldTextline.uid],
        });

        if (!paramsCaller.fieldInfo || !paramsCaller.fieldInfo.field) {
            onError("called a field rendering function without passing a field");
            return "";
        }

        let field = paramsCaller.fieldInfo.field;

        //MATRIX-4981 These are unescaped in the filter.xml and need to be escaped for printing
        let text = field.length ? PrintProcessor.getCdataAsText(field[0], true) : "";

        let rendered = `<span class='${params.class} ${FieldTextline.uid}'>${text}</span>`;

        return rendered;
    }
}

PrintProcessor.addFunction(FieldTextline.uid, new FieldTextline());
